import {
  classes,
  placeHeaderMetadataLabelClass,
  placeHeaderMetadataLinkClass,
  placeHeaderMetadataValueClass,
} from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';

export type PlaceHeaderMetadataProjectProps = {
  readonly projectName: string;
  readonly projectId: string;
  readonly siteUrls: SiteUrls;
};

/**
 * Renders a project link, formatted for use in the place page header
 * @param props
 */
export function PlaceHeaderMetadataProject(props: PlaceHeaderMetadataProjectProps): JSX.Element {
  return (
    <>
      <span className={placeHeaderMetadataLabelClass}>{Messages.Project()}</span>
      <a
        href={props.siteUrls.projectUrl(props.projectId)}
        target='_blank'
        className={classes(placeHeaderMetadataLinkClass, placeHeaderMetadataValueClass)}
        title={props.projectName} rel="noreferrer"
      >
        {props.projectName}
      </a>
    </>
  );
}
